import { motion } from "framer-motion";
import { useNotifications } from "@/contexts/NotificationsContext";

/**
 * Signal stack icon — 3 stacked HUD lines with top line glowing if there are unread.
 * NOT a bell.
 */
export default function SignalStackIcon({ onClick }) {
    const { unread, openDrawer, wsStatus } = useNotifications();
    const handleClick = onClick || openDrawer;
    const live = wsStatus === "open";
    const hasUnread = unread > 0;
    return (
        <button
            type="button"
            onClick={handleClick}
            data-testid="signal-stack-icon"
            aria-label={`Signal feed${hasUnread ? ` · ${unread} unread` : ""}`}
            className="relative inline-flex items-center gap-2 px-3 py-2 rounded-full border border-tca-cyan/22 hover:border-tca-cyan/55 transition-all duration-300"
        >
            <span className="relative inline-block w-4 h-4">
                {/* 3 stacked lines */}
                <motion.span
                    animate={hasUnread ? { opacity: [1, 0.5, 1], scaleX: [1, 1.04, 1] } : { opacity: 1 }}
                    transition={{ duration: 2, repeat: hasUnread ? Infinity : 0 }}
                    className="absolute top-[2px] left-0 right-0 h-[1.5px] bg-tca-cyan-hi rounded-full"
                    style={{ boxShadow: hasUnread ? "0 0 8px rgba(0,219,255,0.85)" : "none" }}
                />
                <span className="absolute top-[7px] left-0 right-0 h-[1.2px] bg-tca-cyan/70 rounded-full" />
                <span className="absolute top-[12px] left-0 right-0 h-[1px] bg-tca-cyan/45 rounded-full" />
            </span>
            <span className="font-mono-tight text-[10px] uppercase tracking-[0.24em] text-tca-cyan/85">
                Signal
            </span>
            {hasUnread && (
                <span
                    data-testid="signal-stack-badge"
                    className="ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-tca-cyan-hi text-tca-bg-deep text-[10px] font-mono-tight font-bold"
                    style={{ boxShadow: "0 0 10px rgba(0,219,255,0.7)" }}
                >
                    {unread > 99 ? "99+" : unread}
                </span>
            )}
            {!live && hasUnread === false && (
                <span className="ml-1 inline-block w-1 h-1 rounded-full bg-tca-ink-muted/60" title="reconnecting" />
            )}
        </button>
    );
}
